<!--
 * @Author: cryi.liu
 * @Date: 2020-06-17 11:15:17
 * @LastEditTime: 2020-06-18 16:17:01
 * @Description: 阅卷操作栏
-->
<template>
  <div class="action-bar">
    <pss-button text="保存" @on-click="save" />
    <pss-button text="上一题" :disabled="prevBtnDisabled" @on-click="prev" />
    <pss-button text="下一题" :disabled="nextBtnDisabled" @on-click="next" />
    <pss-button text="保存关闭" @on-click="saveAndClose" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActionBar',
  props: {
    questionIndex: { type: Number, required: true },
  },
  computed: {
    ...mapGetters({
      questionList: 'answerMarkStore/questionList',
      markUserAtQuestion: 'answerMarkStore/markUserAtQuestion',
    }),
    prevBtnDisabled() {
      return !(this.questionIndex > 0);
    },
    nextBtnDisabled() {
      return !(this.questionIndex < this.questionList.length - 1);
    },
    hasEdit() {
      const tempMarkUser = JSON.parse(JSON.stringify(this.markUserAtQuestion));
      Object.keys(tempMarkUser).forEach((key) => {
        if (tempMarkUser[key] === null) {
          delete tempMarkUser[key];
        }
      });

      return Object.keys(tempMarkUser).length > 0;
    },
  },
  methods: {
    save() {
      if (!this.hasEdit) {
        alert('当前没有阅卷修改！');
        return;
      }

      this.$emit('save');
    },
    prev() {
      if (this.hasEdit) {
        alert('当前有阅卷未保存，请先保存！');
        return;
      }

      this.$emit('prev');
    },
    next() {
      if (this.hasEdit) {
        alert('当前有阅卷未保存，请先保存！');
        return;
      }

      this.$emit('next');
    },
    saveAndClose() {
      if (!this.hasEdit) {
        alert('当前没有阅卷修改！');
      }

      this.$emit('save-and-close');
    },
  },
};
</script>

<style lang="less" scoped>
.action-bar {
  width: 100%;

  > a {
    margin-right: 8px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
